import type { IntlDateTimeFormat } from 'vue-i18n';

import datetimeDeDE from './i18n/datetime/de-DE.json';
import datetimeEnUS from './i18n/datetime/en-US.json';
import datetimeFrFR from './i18n/datetime/fr-FR.json';
import datetimeRuRU from './i18n/datetime/ru-RU.json';
import datetimeTrTR from './i18n/datetime/tr-TR.json';
import datetimeEsES from './i18n/datetime/es-ES.json';
import datetimeArAE from './i18n/datetime/ar-AE.json';
import datetimeHeIL from './i18n/datetime/he-IL.json';
import datetimeHiIN from './i18n/datetime/hi-IN.json';
import datetimeItIT from './i18n/datetime/it-IT.json';
import datetimeKkKZ from './i18n/datetime/kk-KZ.json';
import datetimeNlNL from './i18n/datetime/nl-NL.json';
import datetimePlPL from './i18n/datetime/pl-PL.json';
import datetimeUkUA from './i18n/datetime/uk-UA.json';
import datetimePtPT from './i18n/datetime/pt-PT.json';
import datetimeRoRO from './i18n/datetime/ro-RO.json';
import datetimeTaIN from './i18n/datetime/ta-IN.json';
import datetimeThTH from './i18n/datetime/th-TH.json';
import datetimeViVN from './i18n/datetime/vi-VN.json';
import datetimeZhCN from './i18n/datetime/zh-CN.json';
import datetimeKoKR from './i18n/datetime/ko-KR.json';

const datetimeFormats = {
  de: datetimeDeDE,
  en: datetimeEnUS,
  fr: datetimeFrFR,
  ru: datetimeRuRU,
  tr: datetimeTrTR,
  es: datetimeEsES,
  ar: datetimeArAE,
  he: datetimeHeIL,
  hi: datetimeHiIN,
  it: datetimeItIT,
  kk: datetimeKkKZ,
  nl: datetimeNlNL,
  pl: datetimePlPL,
  uk: datetimeUkUA,
  pt: datetimePtPT,
  ro: datetimeRoRO,
  ta: datetimeTaIN,
  th: datetimeThTH,
  vi: datetimeViVN,
  zh: datetimeZhCN,
  ko: datetimeKoKR,
} as Record<string, IntlDateTimeFormat>;

export default defineI18nConfig(() => ({
  warnHtmlMessage: false,
  datetimeFormats,
  fallbackLocale: {
    'xx-XX': [],
  },
}));
